import { createAction, props } from '@ngrx/store';
import { Portal } from '../../models/portal.model';

export const LoadSwitcherPortals = createAction('[Portals] Load Switcher Portals');
export const LoadSwitcherPortalsSuccess = createAction('[Portals] Load Switcher Portals Success', props<{ portals: Partial<Portal>[] }>());
export const LoadSwitcherPortalsFail = createAction('[Portals] Load Switcher Portals Fail', props<{ error: any }>());
